import '../styles/LoginPage.css'

import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from "react-i18next";

import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function LoginForm() {

    const { t } = useTranslation();
    const { loginWithRedirect } = useAuth0();
    let navigate = useNavigate();

    const handleClickJoinUs = () => navigate('/register');

    return (
        <div className='login-form-subContainer login-form-subContainer1'>
            <div style={{textAlign:'center'}}>
                <div className='login-form-titles login-form-titles1'>One community. Your security.</div>
                <div className='login-form-subtitles'>{t('login.hunter-paragraph')}</div>
            </div>

            <Button
                fullWidth
                onClick={() => loginWithRedirect()}
                className='login-form__login-button'
                sx={{
                    color: 'white',
                    backgroundColor: "var(--button-background-8)",
                    textTransform: 'none',
                    //borderRadius: '5px',
                    ':hover': { backgroundColor: "var(--button-background-hover-8)" }
                }}
            >
                {t('login.button-connect')}
            </Button>
            <div className='login-page__action-container'>
                <div className='login-form-subtitles login-form-subtitles-2'>{t('login.notRegistered')}</div>
                <div className='login-form-subtitles-buttons'>
                    <Button
                        title={t('links.join-link')} aria-label={t('links.join-link')}
                        target="_blank" rel="noopener noreferrer"
                        variant="contained"
                        fullWidth
                        sx={{
                            color: 'white',
                            textTransform: 'none',
                            fontSize: '13px', fontWeight: '400',
                            padding: '6px 20px',// marginLeft: '10px',
                            whiteSpace: 'nowrap',
                            //borderRadius: '5px',
                            border: ' 1px solid var(--nhub-color-background-6)',
                            backgroundColor: "var(--button-background-hover-9)",
                            ':hover': { backgroundColor: "var(--button-background-9)" }
                        }}
                        onClick={() => { handleClickJoinUs() }} // lorsqu'on ouvrira
                    >
                        {t('login.button-join')}
                    </Button>
                    {t('general.or')}
                    <Button
                        href={t('links.contact-link')}
                        title={t('links.contact-link')} aria-label={t('links.contact-link')}
                        target="_blank" rel="noopener noreferrer"
                        variant="contained"
                        fullWidth
                        sx={{
                            color: 'white',
                            textTransform: 'none',
                            fontSize: '13px', fontWeight: '400',
                            padding: '6px 20px',// marginLeft: '10px',
                            //borderRadius: '5px',
                            whiteSpace: 'nowrap',
                            border: ' 1px solid var(--nhub-color-background-6)',
                            backgroundColor: "var(--button-background-hover-9)",
                            ':hover': { backgroundColor: "var(--button-background-9)" }
                        }}
                    >
                        {t('login.button-contact')}
                    </Button>

                </div>
            </div>



        </div>
    );
};
export default LoginForm;